import { Delete, KeyboardArrowDown } from '@mui/icons-material';
import { Box, Button, CircularProgress, Dialog, DialogContent, Divider, Grid, IconButton, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'sonner';
import { preventPhoneInputKeys } from '../../../components/FormatNumber/FormatNumber';
import { configDetails } from '../../../redux/Account/action';
import { NotificationStatus, updateNotificationStatus } from '../../../redux/Account/Notification/action';
import { getCountryMasterListApi, updateSmsNotificationNumberApi } from '../../../redux/Account/peronalIfno/action';
import { validatePhoneNumber } from '../../../utility/helpers/commonFunction';
import { formatPhoneNumber, inputFormatPhoneNumber, removeDashFromPhoneNumber } from '../../Common/FormatPhoneNumber';

const Notification = () => {
    const dispatch = useDispatch();
    const [showloader, setShowLoader] = useState(false);
    const countryMasterList = useSelector((state) => state.account?.countryMasterList);
    const [defaultCountryId, setDefaultCountryId] = useState('');
    const [isAppointmentRequestSMSNotificationToShopOwnerEnabled, setIsAppointmentRequestSMSNotificationToShopOwnerEnabled] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
        getValues,
        setError,
        setValue,
        clearErrors,
    } = useForm({
        defaultValues: {
            contactPersons: [{ firstName: '', lastName: '', phoneNumberCountry: '', phoneNumber: '' }],
        },
    });

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'contactPersons',
    });

    const onSubmit = async (data) => {
        try {
            setShowLoader(true);
            // Transform the data to match API payload structure
            const payload = {
                isAppointmentRequestSMSNotificationToShopOwnerEnabled,
                contactPersons: data.contactPersons.map((person) => ({
                    firstName: person.firstName?.trim(),
                    lastName: person.lastName?.trim(),
                    phoneNumberCountry: person.phoneNumberCountry,
                    phoneNumber: person.phoneNumber,
                })),
            };

            console.log('Payload:', payload);

            // Call the API
            const response = await updateSmsNotificationNumberApi(payload);

            if (response) {
                toast.success('Changes Saved');
                fetchConfig();
                console.log('API Response:', response);
            }
        } catch (error) {
            console.error('Error updating SMS notification numbers:', error);
        } finally {
            setShowLoader(false);
        }
    };

    const handleCountryChange = (event, index) => {
        const selected = countryMasterList.find((item) => item._id === event.target.value);
        setValue(`contactPersons.${index}.phoneNumberCountry`, event.target.value);
        // Note: Removing country code as it will be +1 for all entries
    };

    const getNotificationRedux = useSelector((state) => state?.account?.getNotificationStatus);

    const [isChecked, setChecked] = useState({
        emailNotificationsNewAppointments: getNotificationRedux?.emailNotificationsNewAppointments,

        emailNotificationsReschedules: getNotificationRedux?.emailNotificationsReschedules,
        emailNotificationsCancellations: getNotificationRedux?.emailNotificationsCancellations,
        emailNotificationsPromotionsandAnnouncements: getNotificationRedux?.emailNotificationsPromotionsandAnnouncements,
        emailNotificationsMessagefromCustomer: getNotificationRedux?.emailNotificationsMessagefromCustomer,
        mobileNotificationsCancellations: getNotificationRedux?.mobileNotificationsCancellations,
        mobileNotificationsMessageFromCustomer: getNotificationRedux?.mobileNotificationsMessageFromCustomer,
        mobileNotificationsNewAppointments: getNotificationRedux?.mobileNotificationsNewAppointments,
        mobileNotificationsPromotionsandAnnouncements: getNotificationRedux?.mobileNotificationsPromotionsandAnnouncements,
        mobileNotificationsReschedules: getNotificationRedux?.mobileNotificationsReschedules,

        emailNotificationsAppointmentConfirmationEmailCreatedFromSaasOrMechanicApp:
            getNotificationRedux?.emailNotificationsAppointmentConfirmationEmailCreatedFromSaasOrMechanicApp,
        mobileNotifications12PMReminderToLogAppointments: getNotificationRedux?.mobileNotifications12PMReminderToLogAppointments,
        mobileNotifications5PMReminderToMarkAppointmentsAsPaid: getNotificationRedux?.mobileNotifications5PMReminderToMarkAppointmentsAsPaid,
        emailNotificationsAppointmentRequestConfirmationEmailCreatedFromSaasOrMechanicApp:
            getNotificationRedux?.emailNotificationsAppointmentRequestConfirmationEmailCreatedFromSaasOrMechanicApp,
    });

    useEffect(() => {
        fetchConfig();
        getNotificationData();
        fetchCountryMasterList();
        // setChecked({ ...getNotificationRedux });
    }, []);

    const fetchConfig = async (hideLoader) => {
        if (!hideLoader) {
            setShowLoader(true);
        }

        try {
            const resp = await dispatch(configDetails());

            if (Array.isArray(resp?.smsNotificationPhoneNumber) && resp.smsNotificationPhoneNumber.length > 0) {
                const formatted = resp.smsNotificationPhoneNumber.map((item) => ({
                    firstName: item.firstName || '',
                    lastName: item.lastName || '',
                    phoneNumber: item.phoneNumber ? formatPhoneNumber(item?.phoneNumber) : '',
                    phoneNumberCountry: item.phoneNumberCountry?._id || '',
                }));
                setIsAppointmentRequestSMSNotificationToShopOwnerEnabled(resp.isAppointmentRequestSMSNotificationToShopOwnerEnabled || false);
                setValue('contactPersons', formatted);
            }
        } catch (error) {
            console.error('Error fetching config:', error);
        } finally {
            setShowLoader(false);
        }
    };

    const fetchCountryMasterList = async () => {
        let resp = await dispatch(getCountryMasterListApi());
        if (resp.length > 0) {
            const selected = resp.find((item) => item.default === true);
            if (selected) {
                setDefaultCountryId(selected._id);
                // Set the default country for the first entry
                // setValue('contactPersons.0.phoneNumberCountry', selected._id);
            }
        }
    };
    useEffect(() => {
        if (defaultCountryId) {
            if (getValues().contactPersons.length === 1 && !getValues().contactPersons[0].phoneNumberCountry) {
                setValue('contactPersons.0.phoneNumberCountry', defaultCountryId);
            }
        }
    }, [defaultCountryId]);

    const getNotificationData = async () => {
        let res = await dispatch(NotificationStatus());
        console.log('🚀 ~ getNotificationData ~ res:', res);
        if (res) {
            const notificationProps = JSON.parse(JSON.stringify(res));
            delete notificationProps._id;
            setChecked(notificationProps);
        }
    };

    const updateData = async (newData) => {
        let res = await dispatch(updateNotificationStatus(newData));
    };

    return (
        <Box padding={'0 24px 24px 20px'} marginTop={'32px'}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} sx={{ boxShadow: 2, bgcolor: 'white' }} padding={'10px'} borderRadius={'8px'}>
                    <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                        <Typography variant="h5" style={{ fontWeight: 400 }} className="style-24-400-32-px">
                            Text
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        container
                        xs={12}
                        sm={12}
                        md={12}
                        lg={8}
                        xl={8}
                        justifyContent={'space-between'}
                        rowGap={3}
                        paddingRight={'16px'}
                        marginY={'16px'}
                    >
                        <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} alignItems={'center'}>
                            <Grid item xs={10} sm={10} md={10} xl={10}>
                                <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={0}>
                                    Appointment Requests
                                </Typography>
                            </Grid>
                            <Grid item>
                                <Switch
                                    checked={isAppointmentRequestSMSNotificationToShopOwnerEnabled}
                                    onChange={() => {
                                        setIsAppointmentRequestSMSNotificationToShopOwnerEnabled(!isAppointmentRequestSMSNotificationToShopOwnerEnabled);
                                    }}
                                    color="primary"
                                    size="medium"
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                            {fields.map((field, index) => (
                                <Grid key={field.id} container item spacing={3} alignItems="flex-start">
                                    {/* First Name */}
                                    <Grid item xs={12} sm={6} md={3} gap={1}>
                                        <Stack gap={1}>
                                            <Typography sx={{ fontSize: '16px', fontWeight: 500, lineHeight: '150%', letterSpacing: '0.15px' }}>
                                                First Name<span className="asterik">*</span>
                                            </Typography>
                                            <Controller
                                                name={`contactPersons.${index}.firstName`}
                                                control={control}
                                                rules={{ required: 'First Name is required' }}
                                                render={({ field }) => (
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        error={!!errors.contactPersons?.[index]?.firstName}
                                                        helperText={errors.contactPersons?.[index]?.firstName?.message}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Grid>

                                    {/* Last Name */}
                                    <Grid item xs={12} sm={6} md={3}>
                                        <Stack gap={1}>
                                            <Typography sx={{ fontSize: '16px', fontWeight: 500, lineHeight: '150%', letterSpacing: '0.15px' }}>
                                                Last Name<span className="asterik">*</span>
                                            </Typography>
                                            <Controller
                                                name={`contactPersons.${index}.lastName`}
                                                control={control}
                                                rules={{ required: 'Last Name is required' }}
                                                render={({ field }) => (
                                                    <TextField
                                                        fullWidth
                                                        variant="outlined"
                                                        error={!!errors.contactPersons?.[index]?.lastName}
                                                        helperText={errors.contactPersons?.[index]?.lastName?.message}
                                                        {...field}
                                                    />
                                                )}
                                            />
                                        </Stack>
                                    </Grid>

                                    {/* Phone Number with Country Code (Fixed to +1) */}
                                    <Grid item xs={12} sm={12} md={6}>
                                        <Stack direction={'row'} gap={1} alignItems={'center'}>
                                            <Stack gap={1} width={'100%'}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: 500, lineHeight: '150%', letterSpacing: '0.15px' }}>
                                                    Phone Number<span className="asterik">*</span>
                                                </Typography>
                                                <Controller
                                                    name={`contactPersons.${index}.phoneNumber`}
                                                    control={control}
                                                    rules={{
                                                        required: 'Phone Number is required',
                                                    }}
                                                    render={({ field }) => (
                                                        <TextField
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <Controller
                                                                        name={`contactPersons.${index}.phoneNumberCountry`}
                                                                        control={control}
                                                                        render={({ field: countryField }) => (
                                                                            <Select
                                                                                style={{
                                                                                    width: '92px',
                                                                                    minWidth: '92px',
                                                                                    height: '56px',
                                                                                    border: 'none',
                                                                                    marginRight: '16.5px',
                                                                                }}
                                                                                MenuProps={{
                                                                                    PaperProps: {
                                                                                        style: {
                                                                                            width: '264px',
                                                                                            marginLeft: '86px',
                                                                                            boxShadow:
                                                                                                'box-shadow: 0px 3px 14px 2px rgba(0, 0, 0, 0.12), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 5px 5px -3px rgba(0, 0, 0, 0.20)',
                                                                                        },
                                                                                    },
                                                                                    MenuListProps: {
                                                                                        style: {},
                                                                                    },
                                                                                }}
                                                                                sx={{
                                                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                                                        border: 'none',
                                                                                    },
                                                                                    '& .MuiOutlinedInput-root': {
                                                                                        borderTopRightRadius: '0px',
                                                                                        borderBottomRightRadius: '0px',
                                                                                    },
                                                                                    borderTopRightRadius: '0px',
                                                                                    borderBottomRightRadius: '0px',
                                                                                    background: '#F1F1F1',
                                                                                }}
                                                                                value={countryField.value || ''}
                                                                                onChange={(event) => handleCountryChange(event, index)}
                                                                                renderValue={(selected) => {
                                                                                    const country = countryMasterList.find((item) => item._id === selected);
                                                                                    if (!country) return '+1';
                                                                                    return (
                                                                                        <div
                                                                                            style={{
                                                                                                display: 'flex',
                                                                                                alignItems: 'center',
                                                                                            }}
                                                                                        >
                                                                                            <span style={{ marginRight: '8px' }}>{country.flag}</span>
                                                                                            +1
                                                                                        </div>
                                                                                    );
                                                                                }}
                                                                                IconComponent={KeyboardArrowDown}
                                                                            >
                                                                                {countryMasterList?.length > 0 &&
                                                                                    countryMasterList.map((country) => (
                                                                                        <MenuItem
                                                                                            key={country._id}
                                                                                            value={country._id}
                                                                                            style={{ height: '44px' }}
                                                                                        >
                                                                                            <span style={{ marginRight: '8px' }}>{country.flag}</span>
                                                                                            {country.country} (+1)
                                                                                        </MenuItem>
                                                                                    ))}
                                                                            </Select>
                                                                        )}
                                                                    />
                                                                ),
                                                            }}
                                                            id="outlined-basic"
                                                            sx={{
                                                                '& .MuiOutlinedInput-root': {
                                                                    paddingLeft: '0',
                                                                },
                                                            }}
                                                            variant="outlined"
                                                            fullWidth
                                                            error={!!errors.contactPersons?.[index]?.phoneNumber}
                                                            helperText={errors.contactPersons?.[index]?.phoneNumber?.message}
                                                            {...field}
                                                            onChange={(e) => {
                                                                if (removeDashFromPhoneNumber(e.target.value).length <= 10) {
                                                                    const input = e.target;
                                                                    const rawValue = e.target.value;
                                                                    const prevCursorPosition = input.selectionStart;
                                                                    const isDeleting = e.nativeEvent.inputType === 'deleteContentBackward';
                                                                    const hyphenCountBefore = (rawValue.match(/-/g) || []).length;
                                                                    const formattedValue = inputFormatPhoneNumber(rawValue);
                                                                    const hyphenCountAfter = (formattedValue.match(/-/g) || []).length;

                                                                    let newCursorPosition = prevCursorPosition;

                                                                    if (isDeleting) {
                                                                        if (hyphenCountAfter < hyphenCountBefore) {
                                                                            newCursorPosition--;
                                                                        }
                                                                    } else {
                                                                        if (hyphenCountAfter > hyphenCountBefore) {
                                                                            newCursorPosition++;
                                                                        }
                                                                    }
                                                                    newCursorPosition = Math.max(0, Math.min(newCursorPosition, formattedValue.length));
                                                                    setValue(`contactPersons.${index}.phoneNumber`, formattedValue);

                                                                    setTimeout(() => {
                                                                        input.setSelectionRange(newCursorPosition, newCursorPosition);
                                                                    }, 0);
                                                                    let nondashedPhoneNumber = e.target.value.toString()?.replace(/-/g, '');
                                                                    if (
                                                                        nondashedPhoneNumber.length == 10 &&
                                                                        validatePhoneNumber(inputFormatPhoneNumber(e.target.value))
                                                                    ) {
                                                                        // checkPhoneNumberExist(getValues().contactPersons[index].phoneNumberCountry);
                                                                    }

                                                                    if (removeDashFromPhoneNumber(e.target.value).length < 10) {
                                                                        setError(`contactPersons.${index}.phoneNumber`, {
                                                                            message: 'Phone Number should be 10 digits',
                                                                        });
                                                                    } else clearErrors(`contactPersons.${index}.phoneNumber`);
                                                                }
                                                            }}
                                                            onKeyDown={(e) => {
                                                                preventPhoneInputKeys(e);
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Stack>

                                            <div style={{ width: '40px', height: '40px', marginTop: '20px' }}>
                                                {index !== 0 && (
                                                    <IconButton onClick={() => remove(index)} color="error">
                                                        <Delete />
                                                    </IconButton>
                                                )}
                                            </div>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            ))}

                            {/* Add Phone Number */}
                            <Box mt={1} pl={3}>
                                <Button
                                    onClick={() => {
                                        if (getValues().contactPersons.length < 5) {
                                            append({
                                                firstName: '',
                                                lastName: '',
                                                phoneNumber: '',
                                                phoneNumberCountry: defaultCountryId,
                                            });
                                        } else {
                                            toast.error('Maximum 5 contact persons are allowed');
                                        }
                                    }}
                                    variant="text"
                                    color="primary"
                                    sx={{
                                        padding: '0!important',
                                        '&:hover': { backgroundColor: 'transparent' },
                                        '&:focus': { backgroundColor: 'transparent' },
                                    }}
                                >
                                    + ADD PHONE NUMBER
                                </Button>
                            </Box>

                            {/* Submit Button */}
                            <Grid item container spacing={2} xs={12} sm={12} md={12} justifyContent={'flex-end'}>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => {
                                            fetchConfig(true);
                                        }}
                                    >
                                        Cancel Changes
                                    </Button>
                                </Grid>

                                <Grid item>
                                    <Button variant="contained" color="primary" type="submit">
                                        Save Changes
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            <Grid container spacing={2} sx={{ boxShadow: 2, bgcolor: 'white' }} padding={'10px'} borderRadius={'8px'} marginTop={'32px'}>
                <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                    <Typography variant="h5" style={{ fontWeight: 400 }} className="style-24-400-32-px">
                        Push Notifications (Mobile)
                    </Typography>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={8}
                    xl={8}
                    spacing={2}
                    justifyContent={'space-between'}
                    rowGap={3}
                    paddingRight={'16px'}
                    marginY={'16px'}
                >
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={8} sm={8} md={8} xl={8}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                New Appointments
                            </Typography>
                            <Typography variant="body1">Get notified when a customer submits an appointment request.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotificationsNewAppointments}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotificationsNewAppointments = !newData.mobileNotificationsNewAppointments;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                Reschedules
                            </Typography>
                            <Typography variant="body1">Receive timely notifications when a customer reschedules an appointment.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotificationsReschedules}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotificationsReschedules = !newData.mobileNotificationsReschedules;

                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                Cancellations
                            </Typography>
                            <Typography variant="body1">Receive timely notifications when a customer cancels an appointment.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotificationsCancellations}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotificationsCancellations = !newData.mobileNotificationsCancellations;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                Message from a Customer
                            </Typography>
                            <Typography variant="body1">Receive instant notifications whenever a customer sends you a message.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotificationsMessageFromCustomer}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotificationsMessageFromCustomer = !newData.mobileNotificationsMessageFromCustomer;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>
                    {/* Promotions & Announcements */}
                    {/* <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} mb={1}>
                                Promotions and Announcements
                            </Typography>
                            <Typography variant="body1">Receive notifications for updates, promotions, and other information.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotificationsPromotionsandAnnouncements}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotificationsPromotionsandAnnouncements = !newData.mobileNotificationsPromotionsandAnnouncements;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid> */}

                    {/* Log Appointments Reminder */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} mb={1}>
                                Log Appointments Reminder
                            </Typography>
                            <Typography variant="body1">
                                Daily reminder at 12 PM to log completed appointments—helps you collect more Google reviews.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotifications12PMReminderToLogAppointments}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotifications12PMReminderToLogAppointments = !newData.mobileNotifications12PMReminderToLogAppointments;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>

                    {/* Google Review Reminder */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} mb={1}>
                                Google Review Reminder{' '}
                            </Typography>
                            <Typography variant="body1">
                                Reminder to mark appointments as “Paid” so Apex can automatically send review requests to customers.
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.mobileNotifications5PMReminderToMarkAppointmentsAsPaid}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.mobileNotifications5PMReminderToMarkAppointmentsAsPaid =
                                        !newData.mobileNotifications5PMReminderToMarkAppointmentsAsPaid;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ boxShadow: 2, bgcolor: 'white' }} padding={'10px'} borderRadius={'8px'} marginTop={'32px'}>
                <Grid item xs={12} sm={12} md={12} xl={4} lg={4}>
                    <Typography variant="h5" style={{ fontWeight: 400 }} className="style-24-400-32-px">
                        Email
                    </Typography>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={8}
                    xl={8}
                    spacing={2}
                    justifyContent={'space-between'}
                    rowGap={3}
                    paddingRight={'16px'}
                    marginY={'16px'}
                >
                    {/* New Appointments  */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                New Appointments
                            </Typography>
                            <Typography variant="body1">Get notified when a customer submits an appointment request.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.emailNotificationsNewAppointments}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.emailNotificationsNewAppointments = !newData.emailNotificationsNewAppointments;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>

                    {/* Reschedules */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                Reschedules
                            </Typography>
                            <Typography variant="body1">Receive a notification when a customer requests to reschedule an appointment.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.emailNotificationsReschedules}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.emailNotificationsReschedules = !newData.emailNotificationsReschedules;

                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>

                    {/* Cancellations  */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} className="btn-text-style" mb={1}>
                                Cancellations
                            </Typography>
                            <Typography variant="body1">Get notified when a customer cancels an existing appointment.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.emailNotificationsCancellations}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.emailNotificationsCancellations = !newData.emailNotificationsCancellations;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>

                    {/* <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} mb={1}>
                                Promotions and Announcements
                            </Typography>
                            <Typography variant="body1">Receive notifications for updates, promotions, and other information.</Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.emailNotificationsPromotionsandAnnouncements}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.emailNotificationsPromotionsandAnnouncements = !newData.emailNotificationsPromotionsandAnnouncements;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid> */}

                    {/* Appointment Confirmations */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} mb={1}>
                                Appointment Confirmations
                            </Typography>

                            <Typography variant="body1">
                                Receive a confirmation email when an appointment is created from Apex Mechanic Web or Mobile
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.emailNotificationsAppointmentConfirmationEmailCreatedFromSaasOrMechanicApp}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.emailNotificationsAppointmentConfirmationEmailCreatedFromSaasOrMechanicApp =
                                        !newData.emailNotificationsAppointmentConfirmationEmailCreatedFromSaasOrMechanicApp;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>

                    {/* Appointment Request Confirmations */}
                    <Grid item container xs={12} sm={12} md={12} xl={12} justifyContent={'space-between'} paddingBottom={2}>
                        <Grid item xs={10} sm={10} md={10} xl={10}>
                            <Typography variant="h6" fontSize={'20px'} mb={1}>
                                Appointment Request Confirmations
                            </Typography>

                            <Typography variant="body1">
                                Receive a confirmation email when an appointment request is accepted from Apex Mechanic Web or Mobile
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={isChecked.emailNotificationsAppointmentRequestConfirmationEmailCreatedFromSaasOrMechanicApp}
                                color="primary"
                                size="medium"
                                onChange={() => {
                                    const newData = { ...isChecked };
                                    newData.emailNotificationsAppointmentRequestConfirmationEmailCreatedFromSaasOrMechanicApp =
                                        !newData.emailNotificationsAppointmentRequestConfirmationEmailCreatedFromSaasOrMechanicApp;
                                    setChecked(newData);
                                    updateData(newData);
                                }}
                            />
                        </Grid>
                        <Divider orientation="horizontal" style={{ width: '100%', marginTop: '8px' }} />
                    </Grid>
                </Grid>
            </Grid>

            <Dialog open={showloader}>
                <DialogContent>
                    <CircularProgress />
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default Notification;
